import { Timestamp } from 'firebase/firestore';

export enum SubscriptionTypes {
  MultiMonth = "MultiMonth",
  Count = "Count",
  Monthly = "Monthly",
}

export enum OfferConstraint {
  WEEKDAY = "Weekday",
  WEEKEND = "Weekend",
  NON_HOLIDAYS = "Non Holidays",
  EVERYDAY = "Everyday"
}
// Define the Review interface
export interface Review {
  id: string; // Unique identifier for the review
  description: string; // Description of the review
  rating: number; // Rating on a scale of 1-5
  comments: string[]; // Array of comments related to the review
  likes: number;
  dislikes: number;
}
export interface OfferType {
  id: string;
  BuzzName: string;
  Description: string;
  OfferCode: string;
  isLive: boolean;
  url: string;
  offerConstraint: OfferConstraint;
  StartDate: Timestamp;
  EndDate: Timestamp;
  Price: number;
}

interface BusinessProfile {
  businessName?: string;
}

export type ReviewType = {
  consumerId: string;
  rating: number;
}

export interface ServiceProvider {
  id: string;
  ServiceTypes?: string[];
  addDummySubscription: boolean;
  businessProfile?: BusinessProfile;
  created_time?: Date;
  delegatedRoles: string[];
  display_name?: string;
  edited_time: Date;
  email?: string;
  phone_number?: string;
  photo_url?: string;
  plundrDescription?: string,
  plundrImages: string[]
  plundrRating: ReviewType[];
  plundrNumber?: string;
}

export interface SubscriptionType {
  id: string;
  Name: string;
  PaymentCycle: string;
  Price: number;
  advance: number;
  geoLocation: {
    hash: string;

    latlang: any;
  };
  picture: string;
  placeAddress: string;
  placeName: string;
  promoPics?: string[];
  type: string;
  BillingType: string;
  cyclePriceArray: any[];// Make promoPics optional
  align2monthlyBoundary: boolean;
  subscriptionType: string;
}

export type Ticket = {
  ticketDetails: string;
  ticketPrice: number;
  ticketCount: number;
};

export type Payments = {
  status: string;
  itemId: string;
  itemType: string;
  providerId: string;
  consumerName: string;
  mobileNumber: string;
  email: string;
  purchaseDate: string;
  amount: number;
  ticketDetails: Ticket[];

}


export type EventData = {
  id: string;
  eCategory: string; // "Fitness"
  eEndTime: Timestamp; // "16 Oct"
  eName: string; // "VaishAkh"
  ePromoImage: string; // URL to the promo image
  eRegsStartTime: Timestamp; // "16 Oct"
  eStartTime: Timestamp; // "18 Oct"
  eStatus: string; // "Active"
  eSummary: string; // Description of the event
  eTermsConditions: string; // Terms and conditions for the event
  eVenue: string; // Venue of the event
  isOpen: boolean; // Whether the event is open
  tickets: Ticket[]; // Array of ticket information
  eGeoLocation: eGeoLocation,
  participants: number
};

type eGeoLocation = {
  address: string;
  city: string;
  latlang: any; // [latitude, longitude]
  locality: string;
  pin: string;
  placeName: string;
  state: string;
  sublocalities: string[];
}